import { useState } from 'react'
import { useWindowEventListener } from './useWindowEventListener'

export function useShiftDown() {
  const [shiftDown, setShiftDown] = useState(false)

  useWindowEventListener('keydown', (event) => setShiftDown(event.shiftKey))
  useWindowEventListener('keyup', (event) => setShiftDown(event.shiftKey))

  return shiftDown
}
